import { Modal } from "antd";
import { twMerge } from "tailwind-merge";

import { useBodyScroll } from "@hooks/utils";

import IconCloseNormal from "./icon-close.svg?react";
import classNames from "classnames";

export interface ModalProps {
  className?: string;
  wrapClassName?: string;
  size?: "small";
  title?: string | boolean;
  open?: boolean;
  onOk?: () => void;
  onCancel?: () => void;
  confirmLoading?: boolean;
  children?: React.ReactNode;
  maskClosable?: boolean;
  footer?: React.ReactNode | boolean;
  width?: number;
  iconClassName?: string;
  closable?: boolean;
  closeBtnPosition?: "inner" | "outter";
}

export default ({
  className,
  wrapClassName,
  size,
  title,
  open,
  onOk,
  onCancel,
  confirmLoading,
  children,
  maskClosable,
  footer,
  width,
  iconClassName,
  closable = true,
  closeBtnPosition = "inner",
}: ModalProps) => {
  useBodyScroll(open || false);
  if (open) {
    return (
      <Modal
        className={className}
        wrapClassName={twMerge(size ? `ant-modal-wrap--${size}` : "", wrapClassName)}
        title={title}
        open={open}
        confirmLoading={confirmLoading}
        onOk={onOk}
        onCancel={onCancel}
        mask={{ closable: maskClosable }}
        footer={footer}
        width={width}
        centered
        destroyOnHidden={true}
        closable={closable && closeBtnPosition === "inner"}
      >
        {closable && closeBtnPosition === "outter" && (
          <IconCloseNormal
            onClick={onCancel}
            className={classNames("absolute -top-[40px] right-0 cursor-pointer w-[24px] h-[24px]", iconClassName)}
          ></IconCloseNormal>
        )}
        {children}
      </Modal>
    );
  }
  return null;
};
